import Cookies from 'js-cookie';
import { setFormAssemblyState } from 'js/utils/FormAssemblySubmit';
import ProgrammaticDialog from 'js/utils/ProgrammaticDialog';
import cookieName from '../restrictedContentCookieName';

/**
 * Component for Modal Signup Form.
 */
export default class ModalSignup {
  /**
   * Start the component.
   */
  constructor({ element, children, options }) {
    this.element = element;
    this.children = children;
    this.options = options;

    // Bind class methods.
    this.init = this.init.bind(this);
    this.handleFormState = this.handleFormState.bind(this);

    if ('true' !== Cookies.get(cookieName)) {
      const { form } = this.children;

      if ('ready' === form?.faReadyState) {
        this.init();
      } else {
        form.addEventListener('sn.formready', this.init);
      }
    }
  }

  /**
   * Handle form submission state.
   *
   * @param {Event} event The event object.
   */
  handleFormState(event) {
    const { detail = {} } = event;
    const { status = '' } = detail;

    setFormAssemblyState(this.element, detail);

    if ('success' === status) {
      Cookies.set(cookieName, true, { expires: 30 });
      this.dialog.hide();
    }
  }

  /**
   * Initialize the FormAssemblySubmit instance.
   */
  init() {
    const { form } = this.children;
    this.dialog = new ProgrammaticDialog(this.element);

    // Show the Dialog by default.
    this.dialog.show();

    form.addEventListener('sn.formstatechange', this.handleFormState);
  }
}
